const api = {
  // 登录
  loginUrl: 'https://api.e.v1.i-sada.net/v2/api-token-auth',
  // 项目信息 在线统计 配电箱列表
  projectInfo: 'https://api.e.v1.i-sada.net/v2/box/project/',
  // 报警统计
  ticketDay: 'https://api.e.v1.i-sada.net/stat/project/',
  ticketWeek: 'https://api.e.v1.i-sada.net/stat/project/',
  ticketMonth: 'https://api.e.v1.i-sada.net/stat/project/',
  // 实时电能数据
  metricUrl: 'https://api.e.v1.i-sada.net/metric/project/',
  // 电量、电压、电流、漏电、温度趋势
  seriesUrl: 'https://api.e.v1.i-sada.net/v5/data/series',
  // 实时报警
  latestAlarm: 'https://api.e.v1.i-sada.net/diary/project/',
  // 负荷分布
  boxMetric: 'https://api.e.v1.i-sada.net/metric/box/'
}
export default api



// WEBPACK FOOTER //
// ./src/api/index.js